import React from "react";
import { ManageSourcesMasterContainer } from "../../../containers";

const ManageSourcesMaster = (props) => {
  return <ManageSourcesMasterContainer {...props} />;
};

export default ManageSourcesMaster;
